import * as React from 'react';
import {useEffect, useState} from 'react';
import {actions as opportunitiesActions, selectors as opportunitySelectors} from '../../../../Ducks/opportunity';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import CalendarWidget from "../../Calendar/Widgets/CalendarWidget/Calendar";
import {selectors as accountSelectors} from "../../../../Ducks/account";
import {Grid} from "@mui/material";
import {getWeekStartEndDate} from "../../../Utils/dateUtils";

function Actions(props) {

    const {calendar, events, followUps, cronofyAuthorized, getAllEvents, handleDateRangeCallback} = props;
    const [legacyEvents, setLegacyEvents] = useState([]);
    const [legacyFollowUps, setLegacyFollowUps] = useState([]);
    const [dateRange, setDateRange] = useState({});

    useEffect(() => {
        renderCalendarData()
    }, []);

    const renderCalendarData = () => {
        const currentWeek = getWeekStartEndDate(new Date());
        setDateRange(currentWeek);
        getAllEvents(currentWeek);
    }

    useEffect(() => {
        if (calendar) {
            if (Array.isArray(calendar)) {
                setLegacyEvents(calendar);
            } else if (calendar) {
                setLegacyEvents([calendar]);
            }
        }
    }, [calendar]);

    useEffect(() => {
        if (followUps) {
            if (Array.isArray(followUps)) {
                setLegacyFollowUps(followUps);
            } else if (followUps) {
                setLegacyFollowUps([followUps]);
            }
        }
    }, [followUps]);

    useEffect(() => {
        handleDateRangeCallback(dateRange);
    }, [dateRange]);

    return (
        <Grid container>
            <Grid item xs={12}>
                <CalendarWidget {...props} isClickable events={cronofyAuthorized ? events : []}
                                legacy_events={legacyEvents} follow_ups={legacyFollowUps} dateRange={dateRange}
                                setDateRange={setDateRange}/>
            </Grid>
        </Grid>
    );
}

const mapStateToProps = (state) => ({
    calendar: opportunitySelectors.calendar(state),
    events: opportunitySelectors.events(state),
    followUps: opportunitySelectors.followUps(state),
    cronofyAuthorized: accountSelectors.cronofyAuthorized(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getAllEvents: opportunitiesActions.getAllEvents,
    },
    dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Actions);
